import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { canonicalForPath } from '../lib/publicUrls';

export function updatePageCanonical(pathname) {
  const canonical = canonicalForPath(pathname);
  // The SPA shell cannot know the requested page. It intentionally has no
  // hard-coded homepage canonical; one route-aware tag is installed here.
  document.querySelectorAll('link[rel="canonical"], meta[property="og:url"]').forEach(el => el.remove());
  if (!canonical) return;
  const link = document.createElement('link');
  link.rel = 'canonical';
  link.href = canonical;
  document.head.appendChild(link);
  const og = document.createElement('meta');
  og.setAttribute('property', 'og:url');
  og.content = canonical;
  document.head.appendChild(og);
}

export default function PublicPageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => { updatePageCanonical(pathname); }, [pathname]);
  return null;
}
